import React, { ReactElement, useRef } from "react";
import { Translate } from "react-redux-i18n";
import { useAppSelector } from "redux/hooks";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  TableContainer
} from "@mui/material";
import FontAwesomeIcon from "components/shared/FontAwesomeIcon";
import styles from './styles.module.scss'
import { convertBeginToDate, convertOddValue } from "services/utils";

export default function EventsDesktop(): ReactElement {
  const playedCoupon = useAppSelector(state => state.coupon.playedCoupon);
  const tableRef = useRef<null | HTMLTableElement>(null);

  return (
    <TableContainer className={styles.tableContainer}>
      <Table stickyHeader size="small" ref={tableRef} >
        <TableHead>
          <TableRow className={styles.tableHeader}>
            <TableCell>
              <Translate value="couponDetail.codeEvent" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.idEvent" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.date" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.sport" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.category" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.tournament" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.event" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.market" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.odd" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.value" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.result" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.fixed" />
            </TableCell>
            <TableCell>
              <Translate value="couponDetail.state" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            playedCoupon &&
            playedCoupon.odds.map(element => {
              const fullTime = convertBeginToDate(element.event.begin)
              const date = fullTime.split(" ")[0]
              const time = fullTime.split(" ")[1]
              return (
                <TableRow
                  key={element.unique}
                  className={styles.tableRow}>
                  <TableCell className={styles.tableCellEvent}>
                    {element.event.short}
                  </TableCell>
                  <TableCell align="right"
                    className={styles.tableCellEvent}
                  >
                    {element.event.id}
                  </TableCell>
                  <TableCell className={styles.tableCellEvent}>
                    {date}&nbsp;{time}
                  </TableCell>
                  <TableCell className={styles.tableCellEvent}>
                    {element.sport.label}
                  </TableCell>
                  <TableCell className={styles.tableCellEvent}>
                    {element.category.label}
                  </TableCell>
                  <TableCell className={styles.tableCellEvent}>
                    {element.tournament.label}
                  </TableCell>
                  <TableCell className={styles.tableCellEvent}>
                    {element.event.label}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={styles.tableCellEvent}
                  >
                    {element.market.label}
                  </TableCell>
                  <TableCell align="center" className={styles.tableCellEvent}>
                    ({element.odd.label})&nbsp;
                    {element.odd.extra.length > 0 ?
                      element.odd.extra
                      : element.odd.spread
                    }
                  </TableCell>
                  <TableCell
                    align="center"
                    className={styles.tableCellEvent}
                  >
                    {convertOddValue(element.value)}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={styles.tableCellEvent}
                  >
                    {element.event.result}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={styles.tableCellEvent}
                  >
                    {
                      !element.odd.fix ?
                        <></>
                        :
                        <Box className={styles.fixedLabel}>
                          <FontAwesomeIcon name="check" type="fas" />
                        </Box>}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={styles.tableCellEvent}
                  >
                    <Box className={
                      //when its running = yellow , void = white , winner green , else red
                      element.odd.running
                        ? styles.stateYellow
                        : element.odd.winner
                          ? styles.stateGreen
                          : element.odd.void
                            ? styles.stateWhite
                            : styles.stateRed
                    }
                      component="span">
                      <FontAwesomeIcon type="fas" name="circle" />
                    </Box>
                  </TableCell>
                </TableRow>
              )
            })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}